var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmaLocationOnMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.875 17.9375C35.875 28.9725 24.4719 36.8385 21.3063 38.8099C21.0649 38.9621 20.7854 39.0429 20.5 39.0429C20.2146 39.0429 19.9351 38.9621 19.6937 38.8099C16.529 36.8385 5.125 28.9725 5.125 17.9375C5.125 9.44623 12.0087 2.5625 20.5 2.5625C28.9913 2.5625 35.875 9.44623 35.875 17.9375Z",
    fill: "#3B86FF",
    stroke: "#AACBFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.16 18.0399C31.16 20.8671 30.0369 23.5785 28.0377 25.5776C26.0386 27.5768 23.3272 28.6999 20.5 28.6999C17.6728 28.6999 14.9613 27.5768 12.9622 25.5776C10.9631 23.5785 9.83997 20.8671 9.83997 18.0399C9.83997 15.2127 10.9631 12.5013 12.9622 10.5021C14.9613 8.50299 17.6728 7.37988 20.5 7.37988C23.3272 7.37988 26.0386 8.50299 28.0377 10.5021C30.0369 12.5013 31.16 15.2127 31.16 18.0399Z",
    fill: "white",
    stroke: "#AACBFF",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9911_28139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5251 12.2315C21.5251 12.7976 21.0662 13.2565 20.5001 13.2565C19.934 13.2565 19.4751 12.7976 19.4751 12.2315C19.4751 11.6655 19.934 11.2065 20.5001 11.2065C21.0662 11.2065 21.5251 11.6655 21.5251 12.2315Z",
    stroke: "#3B86FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2334 21.7979C23.2334 21.2319 22.0096 20.7729 20.5001 20.7729C18.9905 20.7729 17.7667 21.2319 17.7667 21.7979C17.7667 22.364 18.9905 22.8229 20.5001 22.8229C21.6322 22.8229 22.5501 23.2819 22.5501 23.8479C22.5501 24.414 21.6322 24.8729 20.5001 24.8729C19.6221 24.8729 18.873 24.597 18.5809 24.209",
    stroke: "#3B86FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 13.2563V20.773",
    stroke: "#3B86FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9441 18.0048C15.5668 19.1701 14.2366 17.18 13.6667 15.8026C14.2701 15.8026 15.5258 15.4242 16.6932 14.0945C17.203 13.514 17.4579 13.2237 17.6015 13.2593C17.7452 13.2949 17.9424 13.7293 18.3369 14.5981C18.9468 15.9412 19.8628 16.647 20.5001 16.9037C18.8601 19.5464 17.4461 18.7389 16.9441 18.0048ZM16.9441 18.0048C17.1457 17.8343 17.3483 17.5961 17.5497 17.2785",
    stroke: "#3B86FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0561 18.0048C25.4334 19.1701 26.7636 17.18 27.3335 15.8026C26.7301 15.8026 25.4744 15.4242 24.307 14.0945C23.7972 13.514 23.5423 13.2237 23.3987 13.2593C23.255 13.2949 23.0578 13.7293 22.6633 14.5981C22.0534 15.9412 21.1374 16.647 20.5001 16.9037C22.1401 19.5464 23.5541 18.7389 24.0561 18.0048ZM24.0561 18.0048C23.8545 17.8343 23.6519 17.5961 23.4505 17.2785",
    stroke: "#3B86FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9911_28139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4,
    height: 16.4,
    fill: "white",
    transform: "translate(12.3 9.83984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmaLocationOnMap);
export default __webpack_public_path__ + "static/media/pharmaLocationOnMap.31d51d619a54dfca675724179c41aadb.svg";
export { ForwardRef as ReactComponent };